import React from 'react';
import { FUNDING_LENDER_TYPES, FUNDING_MATCH_FIT_TIERS, FUNDING_PRODUCT_TYPES } from '../../utils/funding/constants';

const FundingMatchFilters = ({
  lenderType,
  productType,
  fitTier,
  onLenderTypeChange,
  onProductTypeChange,
  onFitTierChange,
}) => (
  <div className="grid gap-3 sm:grid-cols-3">
    <label className="block text-sm">
      <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Lender type</span>
      <select
        value={lenderType}
        onChange={(event) => onLenderTypeChange(event.target.value)}
        className="w-full rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2 text-sm text-[var(--fg-text)]"
      >
        <option value="">All types</option>
        {FUNDING_LENDER_TYPES.map((type) => (
          <option key={type} value={type}>{type}</option>
        ))}
      </select>
    </label>

    <label className="block text-sm">
      <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Product type</span>
      <select
        value={productType}
        onChange={(event) => onProductTypeChange(event.target.value)}
        className="w-full rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2 text-sm text-[var(--fg-text)]"
      >
        <option value="">All products</option>
        {FUNDING_PRODUCT_TYPES.map((type) => (
          <option key={type} value={type}>{type}</option>
        ))}
      </select>
    </label>

    <label className="block text-sm">
      <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Fit tier</span>
      <select
        value={fitTier}
        onChange={(event) => onFitTierChange(event.target.value)}
        className="w-full rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2 text-sm text-[var(--fg-text)]"
      >
        <option value="">All tiers</option>
        {FUNDING_MATCH_FIT_TIERS.map((tier) => (
          <option key={tier} value={tier}>{tier}</option>
        ))}
      </select>
    </label>
  </div>
);

export default FundingMatchFilters;
